module.exports = "/static/assets/7bd01b358fbe4512260286183d477685.png";